import { BrushDasharrayType, BrushLinecapType } from '@meitu/saas-editor-core/es/version-types';

// 画笔类型列表
export const dasharrayList = [
    { value: BrushDasharrayType.Solid, linecap: BrushLinecapType.Square },
    { value: BrushDasharrayType.Solid, linecap: BrushLinecapType.Round },
    { value: BrushDasharrayType.Square, linecap: BrushLinecapType.Square },
    { value: BrushDasharrayType.Dot, linecap: BrushLinecapType.Round },
    { value: BrushDasharrayType.Dashed, linecap: BrushLinecapType.Round },
];
